import { render, staticRenderFns } from "./CAP0620_pu.vue?vue&type=template&id=f9cb8348&"
import script from "./CAP0620_pu.vue?vue&type=script&lang=js&"
export * from "./CAP0620_pu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports